import { Component, input, output } from '@angular/core';

@Component({
  selector: 'pp-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {

  readonly checked = input<boolean | undefined>(false);
  readonly disabled = input<boolean | undefined>(false);
  readonly id = input<string>();
  readonly label = input<string>();

  readonly checkChanged = output<boolean>();
}
